import { get, post } from './_core'

export function meta() {
    return get('/escort-ads/meta')
}

export function browse(params, { offset, limit }) {
    return get('/escort-ads/', {
        ...params,
        offset,
        limit
    })
}

// The number of unique phones, as in the counters of the list and the menu.
export function total(params) {
    return get('/escort-ads/', {
        ...params,
        only_total: 1,
        limit: 1
    }).then(result=>result.total_phones)
}

export function ad(id) {
    return get(`/escort-ads/${id}`)
}

export function highlights({ city, excludeId, key }) {
    return get('/escort-ads/highlights', {
        city,
        exclude_id: excludeId,
        key
    }).then(result=>result.sections)
}

export function unlockPhone(id, purchase) {
    return post(`/escort-ads/${id}/phone`, purchase ? { purchase: 1 } : {})
}

export function call(id) {
    return post(`/escort-ads/${id}/call`)
}

export function favorite(id, value) {
    return post(`/escort-ads/${id}/favorite`, {
        favorite: value
    })
}

export function note(id, value) {
    return post(`/escort-ads/${id}/note`, {
        note: value
    }).then(result=>result.note)
}

export function report(id, { reason, comment }) {
    return post(`/escort-ads/${id}/report`, {
        reason,
        comment
    })
}

export function review(id, { comment, hygiene, attitude, temperament, discretion, anonymous }) {
    return post(`/escort-ads/${id}/review`, {
        comment,
        hygiene,
        attitude,
        temperament,
        discretion,
        anonymous
    }).then(result=>result && result.ad ? result.ad : result)
}

export function history(type, { offset, limit }) {
    return get('/escort-ads/history', {
        type,
        offset,
        limit
    })
}

export function clearHistory(type) {
    return post('/escort-ads/history/clear', {
        type
    })
}

export function updatesMore() {
    return get('/updates_more')
}
